import { ethereum } from '@0xtorch/core'
import { arbitrum } from 'viem/chains'
import type { Client } from '../../client'
import { createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createArbitrumOneChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}): Chain =>
  createArbitrumOneChainCustom({
    client: createClient({ chain: arbitrum, httpRpcs: arbitrumOneHttpRpcs }),
    explorer: createEtherscanV2({
      name: 'ArbiScan',
      baseUrl: 'https://arbiscan.io',
      chainId: 42_161,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreateArbitrumOneChainCustomParameters = {
  client: Client
  explorer: Explorer
}

export const createArbitrumOneChainCustom = ({
  client,
  explorer,
}: CreateArbitrumOneChainCustomParameters): Chain => ({
  id: 42_161,
  network: 'arbitrum-one',
  name: 'Arbitrum One',
  nativeToken: {
    name: 'Ethereum',
    symbol: 'ETH',
    decimals: 18,
    currency: ethereum,
  },
  wrappedTokenAddresses: new Set([
    '0x82af49447d8a07e3bd95bd0d56f35241523fbab1',
  ]),
  explorer,
  client,
  blockTime: 250,
  coingeckoId: 'arbitrum-one',
  defillamaId: 'arbitrum',
})

export const arbitrumOneHttpRpcs: HttpRpc[] = [
  // Not archiving receipts
  // {
  //   url: 'https://arbitrum.llamarpc.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://arb1.arbitrum.io/rpc',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 160_000n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://rpc.ankr.com/arbitrum',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 3000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://1rpc.io/arb',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://arb-pokt.nodies.app',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 80_000n,
  // },
  // Endpoint not working
  // {
  //   url: 'https://arb-mainnet.g.alchemy.com/v2/demo',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://arbitrum.public.blockpi.network/v1/rpc/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 1024n,
  },
  // Not archiving receipts
  // {
  //   url: 'https://endpoints.omniatech.io/v1/arbitrum/one/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 3000n,
  // },
  // rate limit is too low
  // {
  //   url: 'https://arb-mainnet-public.unifra.io',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://arbitrum.api.onfinality.io/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 2000n,
  },
  // Endpoint not working
  // {
  //   url: 'https://rpc.arb1.arbitrum.gateway.fm',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://arbitrum-one-rpc.publicnode.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://arbitrum-one.publicnode.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 40_000n,
  // },
  // Not archiving receipts
  // {
  //   url: 'https://arbitrum.meowrpc.com',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 40_000n,
  // },
  // Endpoint not working
  // {
  //   url: 'https://api.zan.top/node/v1/arb/one/public',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://arbitrum.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  // Endpoint not working
  // {
  //   url: 'https://public.stackup.sh/api/v1/node/arbitrum-one',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  // Endpoint not working
  // {
  //   url: 'https://api.stateless.solutions/arbitrum-one/v1/demo',
  //   getLogsIsUsable: true,
  //   getLogsMaxBlockRange: 10_000n,
  // },
  {
    url: 'https://arbitrum.rpc.subquery.network/public',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const arbitrumOneWebsocketRpcUrls: string[] = [
  'wss://arbitrum-one.publicnode.com',
]
